/* GOB gift card page · below-the-fold story (V161, 2026-10-19): Home Alone evening.
   Ambient glow, pinned time-lapse (day → dusk → after dark), Boutique Hotel "room by room", steps line,
   rotating reviews, and the final card's value follows the amount picked in the buy box.
   Purchase logic stays in gob-gift-card-club.js. */
(function () {
  var root = document.getElementById('gcc'); if (!root) return;
  var R = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function all(s, f, el) { (el || root).querySelectorAll(s).forEach(f); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function ss(a, b, x) { x = clamp((x - a) / (b - a), 0, 1); return x * x * (3 - 2 * x); }
  function once(el, cb, th) {
    if (R || !('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); cb(); } }, { threshold: th || .2, rootMargin: '0px 0px -8% 0px' });
    io.observe(el);
  }

  var scrollers = [], ticking = false;
  function tick() { ticking = false; scrollers.forEach(function (f) { f(); }); }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(tick); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  function prog(el) { var r = el.getBoundingClientRect(); return clamp(-r.top / Math.max(1, el.offsetHeight - innerHeight), 0, 1); }

  /* ambient light: follows the section in the middle of the screen */
  var amb = root.querySelector('.amb');
  if (amb) scrollers.push(function () {
    var mid = innerHeight / 2, cur = null;
    all('[data-amb]', function (s) { var r = s.getBoundingClientRect(); if (r.top < mid && r.bottom > mid) cur = s; });
    amb.style.setProperty('--ao', cur ? '1' : '0');
    if (cur) amb.style.setProperty('--ac', cur.getAttribute('data-amb'));
  });

  /* time-lapse: afternoon → dusk → after dark while pinned */
  all('.tlp', function (t) {
    var pin = t.querySelector('.tlp-pin'), caps = t.querySelectorAll('.tlp-cap > div'), clock = t.querySelector('.tlp-clock'),
        cb = clock.querySelector('b'), ticks = clock.querySelectorAll('span i'), times = (t.getAttribute('data-times') || '').split('|'), last = -1;
    scrollers.push(function () {
      var p = prog(t), st = p * 2.2;
      pin.style.setProperty('--p', p.toFixed(3));
      pin.style.setProperty('--o2', (R ? 1 : ss(.35, .8, st)).toFixed(3));
      pin.style.setProperty('--o3', (R ? 1 : ss(1.3, 1.75, st)).toFixed(3));
      var k = R ? 2 : (st < .6 ? 0 : st < 1.5 ? 1 : 2);
      if (k !== last) {
        last = k;
        caps.forEach(function (c, i) { c.classList.toggle('on', i === k); });
        if (times[k]) cb.textContent = times[k];
        clock.classList.toggle('lit', k === 2);
        ticks.forEach(function (x, i) { x.classList.toggle('on', i <= k); });
      }
    });
  });

  /* steps: the amber line runs once in view */
  all('.steps3', function (s) { once(s, function () { s.classList.add('on'); }, .5); });

  /* room by room: lines from labels to the lights, drawn once in view; tap a row on phones */
  all('.ana', function (ana) {
    var img = ana.querySelector('.ana-img'), svg = ana.querySelector('.ana-svg'), dim = ana.querySelector('.ana-dim'),
        labs = ana.querySelectorAll('.lab'), pins = ana.querySelectorAll('.pin'), list = ana.parentNode.querySelectorAll('.ana-list li');
    function layout() {
      var A = ana.getBoundingClientRect(), I = img.getBoundingClientRect();
      if (!A.width) return;
      svg.setAttribute('viewBox', '0 0 ' + A.width + ' ' + A.height);
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      labs.forEach(function (l, i) {
        var pin = pins[i]; if (!pin) return;
        var px = I.left - A.left + I.width * parseFloat(pin.style.left) / 100, py = I.top - A.top + I.height * parseFloat(pin.style.top) / 100;
        var L = l.getBoundingClientRect(), right = l.classList.contains('r');
        var lx = right ? L.left - A.left - 14 : L.right - A.left + 14, ly = L.top - A.top + 9;
        var bend = right ? Math.max(lx - 60, px + 20) : Math.min(lx + 60, px - 20);
        var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        p.setAttribute('d', 'M' + lx + ' ' + ly + ' H' + bend + ' L' + px + ' ' + py);
        svg.appendChild(p);
        p.style.setProperty('--len', p.getTotalLength()); p.style.setProperty('--dl', l.style.getPropertyValue('--dl'));
        l._path = p;
      });
    }
    function spot(i, on) {
      var pin = pins[i]; if (!pin) return;
      dim.style.setProperty('--px', pin.style.left); dim.style.setProperty('--py', pin.style.top);
      ana.classList.toggle('spot', on);
      labs.forEach(function (l, j) { l.classList.toggle('hi', on && j === i); if (l._path) l._path.classList.toggle('hi', on && j === i); });
      pins.forEach(function (p, j) { p.classList.toggle('hi', on && j === i); });
      list.forEach(function (li, j) { li.classList.toggle('hi', on && j === i); });
    }
    labs.forEach(function (l, i) { l.addEventListener('pointerenter', function () { spot(i, true); }); l.addEventListener('pointerleave', function () { spot(i, false); }); });
    var cur = -1;
    list.forEach(function (li, i) { var b = li.querySelector('button'); if (b) b.addEventListener('click', function () { cur = cur === i ? -1 : i; spot(i, cur === i); }); });
    layout(); window.addEventListener('resize', layout);
    var im = img.querySelector('img'); if (im && !im.complete) im.addEventListener('load', layout);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    once(ana, function () { layout(); requestAnimationFrame(function () { ana.classList.add('on'); }); }, .35);
  });

  /* reviews: one at a time; the box holds exactly the tallest quote */
  all('.rvq', function (q) {
    var box = q.querySelector('.rvq-box'), figs = q.querySelectorAll('.rvq-box figure'), dots = q.querySelectorAll('.rvq-dots button'), i = 0, timer = 0, vis = false;
    function fit() { box.style.height = ''; var h = 0; figs.forEach(function (f) { h = Math.max(h, f.scrollHeight); }); box.style.height = h + 'px'; }
    function show(k) {
      i = k;
      figs.forEach(function (f, j) { f.classList.toggle('on', j === k); });
      dots.forEach(function (d, j) { d.classList.remove('on'); if (j === k) { void d.offsetWidth; d.classList.add('on'); } });
      clearTimeout(timer);
      if (vis && !R && figs.length > 1) timer = setTimeout(function () { show((i + 1) % figs.length); }, 6500);
    }
    dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j); }); });
    fit(); window.addEventListener('resize', fit); if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; if (vis) show(i); else clearTimeout(timer); }, { threshold: .3 }).observe(q);
  });

  /* check their set: live predictive search, light kits only, every typed word must be in the kit title */
  all('[data-chk]', function (c) {
    var inp = c.querySelector('input'), res = c.querySelector('.chk-res'), url = c.getAttribute('data-url'),
        okTxt = c.getAttribute('data-ok') || 'Has a kit', noneTxt = c.getAttribute('data-none') || '', timer = 0, seq = 0, cache = {};
    function esc(s) { return String(s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
    function norm(s) { return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim(); }
    function show(q, list) {
      var words = norm(q).split(' ');
      var kits = list.filter(function (p) {
        if (!/^light kit for/i.test(p.title)) return false;
        var t = norm(p.title); return words.every(function (w) { return t.indexOf(w) > -1; });
      });
      if (!kits.length) { res.innerHTML = '<div class="chk-none"><b>No kit for “' + esc(q) + '” yet.</b>' + esc(noneTxt) + '</div>'; return; }
      res.innerHTML = kits.slice(0, 4).map(function (p) {
        var name = p.title.replace(/^light kit for\s*(lego®?\s*)?/i, ''), m = name.match(/\b(\d{4,6})\b(?!.*\b\d{4,6}\b)/), num = m ? m[1] : '';
        if (num) name = name.replace(new RegExp('\\s*' + num + '\\b'), '');
        return '<a href="' + esc(p.url) + '">' + (num ? '<span class="num">' + num + '</span>' : '') + '<span class="nm">' + esc(name) + '</span><span class="ok"><i></i><span>' + esc(okTxt) + '</span></span></a>';
      }).join('') + (kits.length > 4 ? '<p class="chk-more">+ ' + (kits.length - 4) + ' more</p>' : '');
    }
    function run() {
      var q = inp.value.trim(); clearTimeout(timer);
      if (norm(q).length < 2) { res.innerHTML = ''; return; }
      if (cache[q]) { show(q, cache[q]); return; }
      timer = setTimeout(function () {
        var my = ++seq;
        fetch(url + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) { if (my !== seq) return; var list = (d && d.resources && d.resources.results && d.resources.results.products) || []; cache[q] = list; show(q, list); })
          .catch(function () { if (my === seq) res.innerHTML = ''; });
      }, 220);
    }
    inp.addEventListener('input', run);
    c.querySelectorAll('.chk-pop button').forEach(function (b) { b.addEventListener('click', function () { inp.value = b.getAttribute('data-q'); run(); }); });
  });

  /* final card: same value as the amount picked in the buy box */
  var fv = root.querySelector('.js-finval'), fs = root.querySelector('.js-finsym');
  function setFinal(label) {
    if (!fv || !label) return;
    var sym = label.charAt(0), num = label.slice(1);
    if (/[0-9]/.test(sym)) { sym = ''; num = label; }
    if (fs) fs.textContent = sym; fv.textContent = num;
  }
  all('.amtg button', function (b) { b.addEventListener('click', function () { setFinal(b.getAttribute('data-label')); }); });

  requestAnimationFrame(onScroll);
})();
